module.exports = __webpack_public_path__ + "static/media/ex-tocken-img1.ce6ed28d.svg";